import React from 'react'
import { Form, Select } from 'antd'
import { profileScreen } from '../../../../translates'
import { AppConfig } from '../../../../AppConfig'

function LegalFormItemV2 ({
  onChange = () => {},
  disabled = false,
  label = profileScreen.input.legalForm.label,
  required
}) {
  return (
    <Form.Item
      name={['personalData', profileScreen.input.legalForm.name]}
      label={label}
      rules={[{ required: required, message: profileScreen.input.legalForm.message }]}
    >
      <Select
        size='large'
        placeholder='Выберите статус'
        disabled={disabled}
        onChange={onChange}
      >
        {
          AppConfig.legalForms.map(c => <Select.Option key={c} value={c}>{c}</Select.Option>)
        }
      </Select>
    </Form.Item>
  )
}

export default LegalFormItemV2
